<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Send Email:</label>
        <div>
          <model-select
            :options="sendOptions"
            v-model="editSend"
            placeholder="Send Email"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Email Title:</label>
        <div>
          <input type="text" placeholder="Email Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Email Content:</label>
        <div>
          <textarea
            rows="5"
            placeholder="Email Content"
            v-model="editContent"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Send SMS:</label>
        <div>
          <model-select
            :options="sendOptions"
            v-model="editSendSMS"
            placeholder="Send SMS"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>SMS Content:</label>
        <div>
          <textarea
            rows="5"
            placeholder="SMS Content"
            v-model="editSMSContent"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";
import { ModelSelect } from "vue-search-select";

export default {
  props: ["propsData"],
  components: {
    spinnerButton,
    ModelSelect,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editType: null,
      submitLoading: false,
      editName: null,
      editSend: null,
      editTitle: null,
      editContent: null,
      editSendSMS: null,
      editSMSContent: null,

      sendOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Role Status";
        this.buttonLabel = "Add Role Status";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Role Status";
        this.buttonLabel = "Edit Role Status";
      }
      this.editName = this.propsData.name;
      this.editSend = this.propsData.send;
      this.editTitle = this.propsData.title;
      this.editContent = this.propsData.content;
      this.editSendSMS = this.propsData.send_sms;
      this.editSMSContent = this.propsData.sms_content;
      this.submitLoading = false;
    },
    buttonClick: function () {
      const data = {
        name: this.editName ? this.editName : null,
        send: this.editSend ? this.editSend : false,
        title: this.editTitle ? this.editTitle : null,
        content: this.editContent ? this.editContent : null,
        send_sms: this.editSendSMS ? this.editSendSMS : false,
        sms_content: this.editSMSContent ? this.editSMSContent : null,
      };

      if (this.editType === "add") {
        this.submitLoading = true;
        database
          .addDoc("role_statuses", data)
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "add success",
              });
              this.$emit("closePanel");
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } else if (this.editType === "edit") {
        this.submitLoading = true;
        database
          .updateDocById("role_statuses", this.propsData.id, data)
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "edit success",
              });
              this.$emit("closePanel");
            } else {
              this.$toasted.global.toast_error({ message: "edit error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
  },
};
</script>
